import { isEventInclude1X2market } from '../../utils/Helper';
import { GAMES_WITH_1X2 } from '../../constants/appConfig';

export const eventListSorter = (events) => {
    return events.sort((a, b) => {
        if (a.priority > b.priority) {
            return 1;
        }
        if (a.priority < b.priority) {
            return -1;
        }

        if (a.kickoff > b.kickoff) {
            return 1;
        }
        if (a.kickoff < b.kickoff) {
            return -1;
        }

        if (a.eventName) {
            if (a.eventName > b.eventName) {
                return 1;
            }

            if (a.eventName < b.eventName) {
                return -1;
            }
        }

        if (a.eventId > b.eventId) {
            return 1;
        }

        if (a.eventId < b.eventId) {
            return -1;
        }

        return 0;
    });
};

export const splitEventsByAwayTeam = (events) => {
    let eventsWithAwayTeam = [],
        eventsWithoutAwayTeam = [];

    events.map((item) => {
        if (item.awayTeam !== null) {
            eventsWithAwayTeam.push(item);
        } else {
            eventsWithoutAwayTeam.push(item);
        }
    });

    return {
        eventsWithAwayTeam: eventsWithAwayTeam,
        eventsWithoutAwayTeam: eventsWithoutAwayTeam,
    };
};

export const getGroupEventList = (events, limit = null) => {
    let res = {
        header: { 1: false, X: false, 2: false },
        eventsToRender: [],
        marketSubType: null,
    };
    if (!events || events.length === 0) return res;

    const someEventHas1X2 = events.some(
        (event) => event.marketList && isEventInclude1X2market(event)
    );
    let someGameWith1X2 = events.some((event) =>
        GAMES_WITH_1X2.includes(event.sportId)
    );

    if (someEventHas1X2) {
        res.header['1'] = true;
        res.header['2'] = true;
        if (someGameWith1X2) {
            res.header['X'] = true;
        }
    }

    const { eventsWithAwayTeam, eventsWithoutAwayTeam } = splitEventsByAwayTeam(
        events
    );
    const filteredEvents = eventsWithAwayTeam.filter(
        (e) => e?.liveScore || e?.kickoff > Date.now()
    );

    const eventIds = new Set();
    let counter = 0;

    function processMarkets(event) {
        const markets = event.marketList?.filter(
            (market) =>
                event.defaultMarketId === market.marketId ||
                market.mainMarket === 1 ||
                market.marketName === 'Vinder'
        );

        const firstMarket = markets?.[0];

        if (!firstMarket?.itemList) return;

        if (!res.marketSubType) {
            res.marketSubType = markets[0].marketSubType;
        }

        const isVinderspil =
            firstMarket.marketTypeGroup === 11 ||
            firstMarket.marketTypeName?.includes('Vinderspil');

        if (!isVinderspil) {
            for (const item of firstMarket.itemList) {
                const bet = item?.bet?.toUpperCase();
                if (['1', 'X', '2'].includes(bet)) {
                    if (bet === 'X') {
                        res.header['X'] = true;
                    } else if (bet === '1' || bet === '2') {
                        res.header['1'] = true;
                        res.header['2'] = true;
                    }
                }
            }
        }
    }

    const allEvents = [...filteredEvents, ...eventsWithoutAwayTeam];

    for (const event of allEvents) {
        if (!event || eventIds.has(event.eventId)) continue;
        if (limit && counter >= limit) break;

        processMarkets(event);

        res.eventsToRender.push(event);
        eventIds.add(event.eventId);
        counter++;
    }

    return res;
};
